<div class="panel panel-default">
    <div class="panel-heading">
        <h3>Login</h3>
    </div>
    <div class="panel-body">
        <div class="alert alert-danger" ng-show="vm.error">Benutzername und/oder Passwort falsch!</div>
        <form class="form-vertical">
            <div class="form-group">
                <label for="username">Benutzername</label>
                <input type="text" class="form-control" name="username" id="username"
                       autocapitalize="off" autocorrect="off"  spellcheck="false"
                       ng-model="vm.login.username">
            </div>
            <div class="form-group">
                <label for="password">Passwort</label>
                <input type="password" class="form-control" name="password" id="password"
                       autocapitalize="off" autocorrect="off" spellcheck="false"
                       ng-model="vm.login.password" ng-keydown="$event.keyCode === 13 && vm.sendcreds()">
            </div>
            <div class="form-group">
                <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.sendcreds()">Login</button>
            </div>
        </form>
    </div>
</div>
